import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createCollaborator = (request) => {
    // Always use FormData (like createUser) - only append ProfilePicture if it's a File
    const formData = new FormData();
    formData.append('FirstName', request.firstName);
    formData.append('LastName', request.lastName);
    formData.append('Email', request.email);
    formData.append('PhoneNo', request.phoneNo);
    formData.append('CollaboratingCompany', request.collaboratingCompany);
    // Only append ProfilePicture if it's a File
    if (request.profilePictureUrl instanceof File) {
        formData.append('ProfilePicture', request.profilePictureUrl);
    }
    if (request.description) {
        formData.append('Description', request.description);
    }
    formData.append('Type', request.type.toString());
    formData.append('Role', request.role.toString());
    formData.append('AccessLevel', request.accessLevel.toString());
    formData.append('Category', request.category);
    // Append arrays
    request.companyIds.forEach((company, index) => {
        formData.append(`CompanyIds[${index}]`, company);
    });
    if (request.userId) {
        formData.append('UserId', request.userId);
    }
    if (request.isEnabled !== undefined) {
        formData.append('IsEnabled', request.isEnabled.toString());
    }
    // Append collaborator documents
    if (request.collaboratorDocuments && request.collaboratorDocuments.length > 0) {
        request.collaboratorDocuments.forEach((doc, index) => {
            formData.append(`CollaboratorDocuments[${index}]`, doc.file);
            formData.append(`CollaboratorDocumentTypes[${index}]`, doc.type.toString());
            formData.append(`CollaboratorDocumentLanguageIds[${index}]`, doc.languageId);
        });
    }
    return vdkEmHappinessPortalApi.post('/collaborators/create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const updateCollaborator = (request) => {
    // Always use FormData (like updateUser) - only append ProfilePicture if it's a File
    const formData = new FormData();
    formData.append('Id', request.id);
    formData.append('FirstName', request.firstName);
    formData.append('LastName', request.lastName);
    formData.append('Email', request.email);
    formData.append('PhoneNo', request.phoneNo);
    formData.append('CollaboratingCompany', request.collaboratingCompany);
    request.companyIds.forEach((company, index) => {
        formData.append(`CompanyIds[${index}]`, company);
    });
    // Only append ProfilePicture if it's a File
    if (request.profilePictureUrl instanceof File) {
        formData.append('ProfilePicture', request.profilePictureUrl);
    }
    if (request.description) {
        formData.append('Description', request.description);
    }
    formData.append('Type', request.type.toString());
    formData.append('Role', request.role.toString());
    formData.append('AccessLevel', request.accessLevel.toString());
    formData.append('Category', request.category);
    if (request.userId) {
        formData.append('UserId', request.userId);
    }
    if (request.isEnabled !== undefined) {
        formData.append('IsEnabled', request.isEnabled.toString());
    }
    // Append collaborator documents
    if (request.collaboratorDocuments && request.collaboratorDocuments.length > 0) {
        request.collaboratorDocuments.forEach((doc, index) => {
            formData.append(`CollaboratorDocuments[${index}]`, doc.file);
            formData.append(`CollaboratorDocumentTypes[${index}]`, doc.type.toString());
            formData.append(`CollaboratorDocumentLanguageIds[${index}]`, doc.languageId);
        });
    }
    return vdkEmHappinessPortalApi.put('/collaborators/update', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const getAllCollaborators = (request) => {
    return vdkEmHappinessPortalApi.post('/collaborators/get-all', request || {});
};
const getCollaboratorById = (id) => {
    return vdkEmHappinessPortalApi.get(`/collaborators/${id}`);
};
const getCollaboratorByUserId = (userId) => {
    return vdkEmHappinessPortalApi.get(`/collaborators/by-user-id/${userId}`);
};
const signCollaboratorNDA = (collaboratorId, signatureBase64, languageId) => {
    return vdkEmHappinessPortalApi.post('/collaborators/sign-nda', {
        collaboratorId,
        signatureBase64,
        languageId: languageId || null
    });
};
const deleteCollaborator = (id) => {
    return vdkEmHappinessPortalApi.delete(`/collaborators/${id}`);
};
const enableCollaborator = (id) => {
    return vdkEmHappinessPortalApi.patch(`/collaborators/${id}/enable`, {});
};
const disableCollaborator = (id) => {
    return vdkEmHappinessPortalApi.patch(`/collaborators/${id}/disable`, {});
};
const getCollaboratorsByEvent = (eventId, accessLevel) => {
    return vdkEmHappinessPortalApi.get(`/collaborators/event-collaborators/${eventId}/${accessLevel}`);
};
const getAllCollaboratorsByCompany = (companyIds) => {
    return vdkEmHappinessPortalApi.post('/collaborators/get-all-collaborators-by-company', {
        companyIds: companyIds
    });
};
const collaboratorAPI = {
    createCollaborator,
    updateCollaborator,
    getAllCollaborators,
    getCollaboratorById,
    getCollaboratorByUserId,
    signCollaboratorNDA,
    deleteCollaborator,
    enableCollaborator,
    disableCollaborator,
    getCollaboratorsByEvent,
    getAllCollaboratorsByCompany
};
export default collaboratorAPI;
